export const ACTION_RESET = 'FETCH_EVENTSPAGE_RESET';
export const ACTION_REQUEST = 'FETCH_EVENTSPAGE_REQUEST';
export const ACTION_SUCCESS = 'FETCH_EVENTSPAGE_SUCCESS';
export const ACTION_ERROR = 'FETCH_EVENTSPAGE_ERROR';
